<script lang="ts">
  import Checkbox from '../Checkbox/Checkbox.svelte'

  export let label: string 
  export let value: boolean
</script>

<div class="form-group">
  <Checkbox bind:value {label} />
</div>

<style lang="scss">
  .form-group {
    margin-bottom: 24px;
    border: 1px solid #B6C8F9;
    padding: 12px;
    background-color: white;
    outline: none;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0em;
    color: #30333D;
  }
</style>